import requestModule from '@/application/libs/requestModule'
import Util from '@/application/libs/util'

const _getCDFILIAL = () => Util.getFilterInSession().CDFILIAL;
const _getCDSERVFILI = () => Util.getFilterInSession().CDSERVFILI;
const _getIDTIPORESTRICAO = () => Util.getFilterInSession().TPCONTRATO;
const _getNRORG = () => Util.getLocalVar('userData').NRORG;
const _getDTMESCARD = () => Util.getFilterInSession().DTMESCARD;
const _getCDOPERADOR = () => Util.getLocalVar('userData').CDOPERADOR

const defaultResponseFormatter = (response) => {
    let returnValue = response;
    if(response.dataset) {
        returnValue = response.dataset.data;
    } else if(response.error) {
        throw response;
    }
    return returnValue;
};

export default {

    insertPortioningSet: function({CDGRTIPOPR, VRCONJUNTOPORCAO}) {
        return requestModule.postRequest('insertData', {
            FROM: "PORTIONING_SET",
            PARAMS: [{
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                NRORG: _getNRORG(),
                CDGRTIPOPR,
                VRCONJUNTOPORCAO
            }]
        }).then(defaultResponseFormatter)
    },

    updatePortioningSet: function({NRCONJUNTOPORCAO, VRCONJUNTOPORCAO}) {
        return requestModule.postRequest('updateData', {
            FROM: "PORTIONING_SET",
            PARAMS: [{
                NRCONJUNTOPORCAO,
                VRCONJUNTOPORCAO,
                NRORG: _getNRORG()
            }]
        }).then(defaultResponseFormatter)
    },

    removePortioningSet: function(NRCONJUNTOPORCAO) {
        return requestModule.postRequest('deleteData', {
            FROM: "PORTIONING_SET",
            PARAMS: NRCONJUNTOPORCAO,
            
        }).then(defaultResponseFormatter)
    },

    /**
     * @returns {Promis} portioningSets gathered from server
     *   filtered by CDFILIAL and CDSERVFILI
     */
    getPortioningSets: function() {
        return requestModule.postRequest('getData', {
            FROM: "PORTIONING_SET",
            PARAMS: {
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    insertDayOutRutSet: function({QTCLIESTICAR, QTDOAESTICAR, QTFUNESTICAR, DTEVENTO}) {
        return requestModule.postRequest('insertData', {
            FROM: "DAYS_EVENT_OUT_OF_RUT",
            PARAMS: [{
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                NRORG: _getNRORG(),
                QTCLIESTICAR,
                QTDOAESTICAR,
                QTFUNESTICAR,
                DTEVENTO,
            }]
        }).then(defaultResponseFormatter)
    },

    updateDaysOutRutSet: function({NRCARDIAEVENTO, QTCLIESTICAR, QTDOAESTICAR, QTFUNESTICAR}) {
        return requestModule.postRequest('updateData', {
            FROM: "DAYS_EVENT_OUT_OF_RUT",
            PARAMS: [{
                NRCARDIAEVENTO,
                QTCLIESTICAR,
                QTDOAESTICAR, 
                QTFUNESTICAR
            }]
        }).then(defaultResponseFormatter)
    },

    removeDaysOutRutSet: function(NRCARDIAEVENTO) {
        return requestModule.postRequest('deleteData', {
            FROM: "DAYS_EVENT_OUT_OF_RUT",
            PARAMS: NRCARDIAEVENTO,
        }).then(defaultResponseFormatter)
    },

    /**
     * @returns {Promis} daysOutRutSets gathered from server
     *   filtered by CDFILIAL and CDSERVFILI
     */
    getDaysOutRutSets: function() {
        return requestModule.postRequest('getData', {
            FROM: "DAYS_EVENT_OUT_OF_RUT",
            PARAMS: {
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
            }
        }).then(response=> {
            if(response.dataset && response.dataset.data) {
             response.dataset.data.forEach(elements => {
                 elements.DTEVENTO = elements.DTEVENTO.substring(0, 10);
             });
             return response.dataset.data;
            }
        });
    },

    insertLinkTypeDishes: function({NRSEQCNFCARD, CDSERVFILI, NRSEQCNFCARDORIG, FILIAL_key, CDFILIALORIG, CDSERVORIG}) {
        let filialOrig = FILIAL_key? FILIAL_key: CDFILIALORIG;
        let cdservfili = CDSERVORIG? CDSERVORIG: CDSERVFILI;
        return requestModule.postRequest('insertData', {
            FROM: "LINK_TYPE_DISHES_BETWEEN_SERVICES",
            PARAMS: [{
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                NRORG: _getNRORG(),
                NRSEQCNFCARD,
                CDFILIALORIG: filialOrig,
                CDSERVORIG: cdservfili,
                NRSEQCNFCARDORIG,
            }]
        }).then(defaultResponseFormatter)
    },

    removeLinkTypeDishes: function(NRTIPOPRATCOMUMSERV) {
        return requestModule.postRequest('deleteData', {
            FROM: "LINK_TYPE_DISHES_BETWEEN_SERVICES",
            PARAMS: NRTIPOPRATCOMUMSERV,
        }).then(defaultResponseFormatter)
    },

    /**
     * @returns {Promis} linkTypeDishesSets gathered from server
     *   filtered by CDFILIAL and CDSERVFILI
     */
    getLinkTypeDishes: function() {
        return requestModule.postRequest('getData', {
            FROM: "LINK_TYPE_DISHES_BETWEEN_SERVICES",
            PARAMS: {
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getDestineDishes: function() {
        return requestModule.postRequest('getData', {
            FROM: "DESTINE_DISHES",
            PARAMS: {
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                TIPOPRAT: null,
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getFilial: function() {
        return requestModule.postRequest('getData', {
            FROM: "FILIAL",
            PARAMS: {
                CDOPERADOR: _getCDOPERADOR(),
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getOriginDishes: function(CDFILIAL, CDSERVFILI) {
        return requestModule.postRequest('getData', {
            FROM: "ORIGIN_DISHES",
            PARAMS: {
                CDFILIAL: CDFILIAL,
                CDSERVORIG: CDSERVFILI,
                TIPOPRAT: null,
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    
    getServOri: function() {
        return requestModule.postRequest('getData', {
            FROM: "ORIGIN_SERVICE",
            PARAMS: {
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                SERVICO: null,
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getServByUnit: function(cdfilial, cdservfili) {
        if (cdfilial === _getCDFILIAL()){
            return requestModule.postRequest('getData', {
                FROM: "ORIGIN_SERVICE",
                PARAMS: {
                    CDFILIAL: _getCDFILIAL(),
                    CDSERVFILI: _getCDSERVFILI(),
                    SERVICO: null,
                }
            }).then(response=>response.dataset && response.dataset.data);
        } else {
            return requestModule.postRequest('getData', {
                FROM: "SERVICOS_UNIDADE",
                PARAMS: {
                    CDFILIAL: cdfilial,
                }
            }).then(response=>response.dataset && response.dataset.data);
        }
    },

    /**
     * @param {String} query a filter for the plateGroupType name and code
     * @param {Number} [maxResults]
     * @returns {Promise} plateGroupType array fetched from the server
     */
    getPlateGroup: function(query, maxResults = 50) {
        return requestModule.postRequest('getData', {
            FROM: "GRUPOTIPOPRATO_NOT_IN_PORTIONING_SET",
            PARAMS: {
                GRUPOPRATO: query, 
                MAX_RESULTS: maxResults,
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    /**
     * Return SERVCONFIG data from backend.
     * 
     * @returns {Promise}
     */
    getServConfig:function(){
        return requestModule.postRequest('getData', {
            FROM:"SERVCONFIG",
            PARAMS:{
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                IDTIPORESTRICAO: _getIDTIPORESTRICAO()
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getMonthServConfig:function(){
        return requestModule.postRequest('getData', {
            FROM:"MONTHSERVCONFIG",
            PARAMS:{
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                IDTIPORESTRICAO: _getIDTIPORESTRICAO()
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    /**
     * Insert new selected settings data,
     * and remove unselected registers.
     * 
     * @param {Array} toSaveData 
     */
    saveSettingsChanges(toSaveData){
        return requestModule.postRequest('updateData', {
            FROM:'SERVCONFIG',
            PARAMS:{
                toSaveData,
                boData: {
                    unit: _getCDFILIAL(),
                    service: _getCDSERVFILI(),
                    nrorg: _getNRORG()
                }
            }
        });
    },
    
    /**
     * Update changes based on the provided 'FROM' parameter
     * 
     * @param {Array} toSaveData - dado a ser salvo
     * @param {String} FROM - identificador da categoria do dado a ser salvo (e.x., 'SERVCONFIG_FIXED_COLUMN' para Fixed Column)
     */
    saveData(toSaveData, FROM) {
        return requestModule.postRequest('updateData', {
            FROM,
            PARAMS: {
                toSaveData
            }
        });
    },

    updateControlMonthRow({IDMESATIVO, NRCONFCARDMESATIVO}){
        return requestModule.postRequest('updateData', {
            FROM:'MONTH_SERVCONFIG_PERC_SOURCE',
            PARAMS:{
                NRCONFCARDMESATIVO: NRCONFCARDMESATIVO,
                IDMESATIVO: IDMESATIVO,
            }
        });
    },

    insertControlMonthRow({CDFILIAL, CDSERVFILI, NRSEQCNFCARD, IDMESATIVO}){
        return requestModule.postRequest('insertData', {
            FROM:'MONTH_SERVCONFIG_PERC_SOURCE',
            PARAMS: [{
                CDFILIAL: CDFILIAL,
                CDSERVFILI: CDSERVFILI,
                NRSEQCNFCARD: NRSEQCNFCARD,
                IDMESATIVO: IDMESATIVO,
            }]
        });
    },

    autoCalculateConsumptionPercentage({CDGRTIPOPR, NRCONJUNTOPORCAO}){
        return requestModule.postRequest('updateData', {
            FROM: "PORTIONING_SET_CALCULATE_CONSUMPTION_PERCENTAGE",
            PARAMS: [{
                NRCONJUNTOPORCAO,
                CDGRTIPOPR,
                CDSERVFILI: _getCDSERVFILI(),
                CDFILIAL: _getCDFILIAL(),
                DTMESCARD: _getDTMESCARD()
            }]
        }).then((res) => defaultResponseFormatter(res)[0])
    },

    generateLists(OBJECTINSERTLIST){
        return requestModule.postRequest('genMoreThanOneList', 
            {
                LIST: OBJECTINSERTLIST,
                NRORG: _getNRORG(),
            }
        ).then(response=>response.dataset && response.dataset.data);
    },

    deleteLists(ARRLIST){
        return requestModule.postRequest('delMoreThanOneList', 
            {
                LIST: ARRLIST,
            }
        ).then(response=>response.dataset && response.dataset.data);
    },

    deleteOverlap(FILISERV){
        return requestModule.postRequest('deleteData', {
            FROM: "DELETE_DAYS_OUT_RUT_OVERLAP",
            PARAMS: [{
                FILISERV: FILISERV
            }],
        }).then(defaultResponseFormatter)
    },

    insertExportData: function(FILISERV, LISTDAYS) {
        return requestModule.postRequest('insertData', {
            FROM: "INSERT_EXPORT_DATA_DAY_OUT_RUT",
            PARAMS: [{
                P_CDFILIAL: _getCDFILIAL(),
                P_CDSERVFILI: _getCDSERVFILI(),
                P_CDOPERADOR: Util.getLocalVar('userData').CDOPERADOR,
                P_FILISERV: FILISERV,
                P_NRLISTA: LISTDAYS,
            }]
        }).then(defaultResponseFormatter)
    },

    saveExportConfCard(FILISERV, TABLE, ITEMS, MODE, PLATEGRID) {
        return requestModule.postRequest('exportCadOtimizador', 
            {
                TABELA: TABLE,
                ITEM: ITEMS,
                FILISERV: FILISERV,
                MODO: MODE,
                PLATEGRID:PLATEGRID,
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                CDOPERADOR: Util.getLocalVar('userData').CDOPERADOR,
                IDTIPORESTRICAO: _getIDTIPORESTRICAO(),
                NRORG: Util.getLocalVar("userData").NRORG,
            }
        ).then(response=>response.dataset);
    }
}